import {
  PROCESS_LOG_ALL,
  PROCESS_LOG_ERROR,
  PROCESS_LOG_GET,
  PROCESS_LOG_LOADING,
} from '../../actions/types';

const initialState = {
  processOfOrder: null,
  isLoading: true,
  isCompleted: true,
};

export default function ProcessLogReducer(state = initialState, action) {
  switch (action.type) {
    case PROCESS_LOG_LOADING:
      return { isLoading: true, isCompleted: true };
    case PROCESS_LOG_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case PROCESS_LOG_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PROCESS_LOG_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    default:
      return state;
  }
}
